import { Void } from "@pdfking/tfunc"
import { defineComponent } from "vue"

export default defineComponent({
  render: Void,
})
